export default __webpack_public_path__ + "static/media/TheProducers.6b87f9ac.JPG";